module.exports = __webpack_public_path__ + "img/pokebowl.200ab6b3.png";